document.addEventListener('DOMContentLoaded', function () {
  const desktopLinks = document.querySelectorAll('.ks-float-item');
  const mobileLinks = document.querySelectorAll('.ks-mobile-world-link');

  const allLinks = [...desktopLinks, ...mobileLinks];
  if (!allLinks.length) return;

  const sectionsMap = new Map();

  allLinks.forEach((link) => {
    const href = link.getAttribute('href');
    if (!href || !href.startsWith('#')) return;

    const section = document.querySelector(href);
    if (!section) return;

    if (!sectionsMap.has(href)) {
      sectionsMap.set(href, {
        id: href,
        section: section,
        links: []
      });
    }

    sectionsMap.get(href).links.push(link);
  });

  const sections = Array.from(sectionsMap.values());
  if (!sections.length) return;

  function setActive(activeId) {
    const activeIndex = sections.findIndex(({ id }) => id === activeId);

    sections.forEach(({ id, links }, index) => {
      links.forEach((link) => {
        link.classList.remove('is-active', 'is-past');

        if (id === activeId) {
          link.classList.add('is-active');
        } else if (activeIndex > -1 && index < activeIndex) {
          link.classList.add('is-past');
        }
      });
    });
  }

  function detectActiveSection() {
    const triggerLine = window.innerHeight * 0.4;
    let activeId = null;

    sections.forEach(({ id, section }) => {
      const rect = section.getBoundingClientRect();
      if (rect.top <= triggerLine && rect.bottom >= triggerLine) {
        activeId = id;
      }
    });

    if (!activeId) {
      const firstVisible = sections.find(({ section }) => {
        const rect = section.getBoundingClientRect();
        return rect.top > 0;
      });

      if (firstVisible) {
        activeId = firstVisible.id;
      } else {
        activeId = sections[sections.length - 1].id;
      }
    }

    setActive(activeId);
  }

  allLinks.forEach((link) => {
    link.addEventListener('click', function () {
      const href = link.getAttribute('href');
      if (href && href.startsWith('#')) {
        setActive(href);
      }
    });
  });

  let lastScroll = window.scrollY;
  const mobileNav = document.querySelector('.ks-mobile-world-nav');

  function handleNavVisibility() {
    if (!mobileNav) return;

    const currentScroll = window.scrollY;

    if (currentScroll > lastScroll + 8) {
      mobileNav.classList.add('is-hidden');
    }

    if (currentScroll < lastScroll - 8) {
      mobileNav.classList.remove('is-hidden');
    }

    lastScroll = currentScroll;
  }

  window.addEventListener('scroll', detectActiveSection, { passive: true });
  window.addEventListener('resize', detectActiveSection);
  window.addEventListener('scroll', handleNavVisibility, { passive: true });

  detectActiveSection();
});